import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "aemo_battery_storage",
  "use": "aemo_battery_storage-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"aemo_battery_storage\"><title>aemo_battery_storage</title><path d=\"M11.262 14.251H4.418V3.372h2.198V1.729h2.522v1.643h2.124zm.85-12.459h-1.394V.149H5.035v1.643H3.567c-.403 0-.73.245-.73.546v12.947c0 .302.327.546.73.546h8.544c.403 0 .73-.244.73-.546V2.338c0-.302-.327-.546-.73-.546z\" /><path d=\"M9.583 11.274H6.098a.79.79 0 1 0 0 1.58h3.485a.79.79 0 0 0 0-1.58zM9.583 7.92H6.098a.79.79 0 1 0 0 1.58h3.485a.79.79 0 0 0 0-1.58zM9.583 4.566H6.098a.79.79 0 1 0 0 1.58h3.485a.79.79 0 0 0 0-1.58z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/aemo_battery_storage.svg
// module id = 154
// module chunks = 0